export const GA_EVENT = "GA_EVENT";
export const SNOWPLOW_IDENTIFY = "SNOWPLOW_IDENTIFY";
